import { cn } from '@/helpers/common';
import NotFound from '@public/mc/stub.svg';

const StubMC = ({
  texts,
  elementClassName,
}: {
  elementClassName?: {
    mainClassName?: string;
    mainTextClassName?: string;
    subTextClassName?: string;
  };
  texts: { mainText: string; subText?: string };
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center mx-auto max-w-[375px]',
        elementClassName?.mainClassName,
      )}
    >
      <NotFound className="w-[120px] h-[120px] flex-shrink-0" />
      <p
        className={cn(
          'mt-7 text-xl font-bold text-center text-main-text-color',
          elementClassName?.mainTextClassName,
        )}
      >
        {texts.mainText}
      </p>
      {texts.subText && (
        <p
          className={cn(
            'mt-3 text-center text-page-text-color2',
            elementClassName?.subTextClassName,
          )}
        >
          {texts.subText}
        </p>
      )}
    </div>
  );
};

export default StubMC;
